module.exports = __webpack_public_path__ + "img/xianzhi-icon.663093b4.png";